import React from "react"; // Modified import
import { Routes as RouterRoutes, Route } from 'react-router-dom'; // Modified import
import ErrorBoundary from './components/ErrorBoundary';
import NotFound from './pages/NotFound';
import Home from './pages/homepage';
import ModelCatalog from './pages/model-catalog';
import ModelViewer from './pages/3d-model-viewer';
import ShoppingCart from './pages/shopping-cart';
import UserAccountDashboard from './pages/user-account-dashboard';
import ResourcesHub from './pages/resources-hub';
import SearchResults from './pages/resources-hub/SearchResults';
import ResourcePage from './pages/resources-hub/ResourcePage';
import SellersToolbox from './pages/sellers-toolbox';
import ManufacturerToolbox from './pages/manufacturer-toolbox';
import BlogPost from './pages/sellers-toolbox/BlogPost';
import SuppliersResource from './pages/suppliers-resource';
import SupportCenter from './pages/support-center';
import CompanyInformation from './pages/company-information';
import ScrollToTop from './components/ScrollToTop';
import TermsOfService from "./pages/terms-of-service";
import PrivacyPolicy from "./pages/privacy-policy";
import CookiePolicy from "./pages/cookie-policy";
import GDPRComplianceCenter from "./pages/gdpr-compliance-center";
import SellerSignup from './pages/seller-signup';
import ManufacturerSignup from './pages/manufacturer-signup';
import SupplierSignup from './pages/supplier-signup';
import SignIn from './pages/signin';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';
import GettingStartedGuide from "./pages/getting-started-guide";
import OrderConfirmation from "./pages/order-confirmation";
import ProductReviewsRatings from "./pages/product-reviews-ratings";
import ReviewSubmissionForm from "./pages/review-submission-form";
import SellerReviewsRatings from "./pages/seller-reviews-ratings"; // NEW: Seller Reviews Page
import ProtectedRoute from './components/ProtectedRoute';
import UnauthorizedPage from './pages/Unauthorized';
import SellerAccountDashboard from './pages/seller-account-dashboard';
import ShopDashboard from './pages/shop-dashboard'; // NEW: Separate Shop Dashboard
import ServicesGarage from './pages/services-garage';
import ManufacturingAccountDashboard from './pages/manufacturing-dashboard';
import PublicStorefront from './pages/storefront/[slug]';
import Signup from './pages/signup'; // NEW: Import Signup component
import CheckoutPortalWrapper from './pages/checkout-portal-wrapper';
import DemoPage from './pages/demo'; // NEW: Import Demo Page
import Careers from './pages/careers'; // NEW: Import Careers Page
import DiagnosticReport from './pages/diagnostic-report'; // NEW: B2B CRM Reports

export default function ProjectRoutes() {
  // Removed useLocation, useAuth, and useEffect hook for page view logging

  return (
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
          <Route path="/" element={<Home />} />
          <Route path="/model-catalog" element={<ModelCatalog />} />
          
          {/* SEO Friendly Routes */}
          
          
          <Route path="/compare/:comparison" element={<ModelCatalog />} />
          
          <Route path="/3d-model-viewer" element={<ModelViewer />} />
          <Route path="/demo" element={<DemoPage />} /> {/* NEW: Demo Route */}
          <Route path="/careers" element={<Careers />} /> {/* NEW: Careers Route */}
          <Route path="/shopping-cart" element={<ShoppingCart />} />
          <Route path="/user-account-dashboard" element={<ProtectedRoute><UserAccountDashboard /></ProtectedRoute>} />
          <Route path="/resources-hub" element={<ResourcesHub />} />
          <Route path="/resources/search" element={<SearchResults />} />
          <Route path="/documentation" element={<ResourcePage title="Documentation" subtitle="Comprehensive guides and technical documentation for OpenGadget" targetPage="documentation" icon="BookOpen" />} />
          <Route path="/api-reference" element={<ResourcePage title="API Reference" subtitle="Detailed technical specifications for the OpenGadget API" targetPage="api-reference" icon="Code" />} />
          <Route path="/tutorials" element={<ResourcePage title="Tutorials" subtitle="Step-by-step guides and video content to help you succeed" targetPage="tutorials" icon="Video" />} />
          <Route path="/blog" element={<ResourcePage title="OpenGadget Blog" subtitle="The latest news, insights, and stories from the 3D manufacturing world" targetPage="blog" icon="FileText" />} />
          <Route path="/sellers-toolbox" element={<SellersToolbox />} />
          <Route path="/manufacturer-toolbox" element={<ManufacturerToolbox />} />
          <Route path="/suppliers-resource" element={<SuppliersResource />} />
          <Route path="/resources-hub" element={<ResourcesHub />} />

          {/* DYNAMIC BLOG POST ROUTES FOR LONG TAIL SEO */}
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/sellers-toolbox/:slug" element={<BlogPost />} />
          <Route path="/seller-toolbox/:slug" element={<BlogPost />} /> {/* DB uses singular */}
          <Route path="/manufacturer-toolbox/:slug" element={<BlogPost />} />
          <Route path="/manufacturer-resource/:slug" element={<BlogPost />} />
          <Route path="/suppliers-resource/:slug" element={<BlogPost />} />
          <Route path="/supplier-resource/:slug" element={<BlogPost />} /> {/* Just in case */}
          <Route path="/resources-hub/:slug" element={<BlogPost />} />
          <Route path="/documentation/:slug" element={<BlogPost />} />
          <Route path="/api-reference/:slug" element={<BlogPost />} />
          <Route path="/tutorials/:slug" element={<BlogPost />} />

          <Route path="/support-center" element={<SupportCenter />} />
          <Route path="/company-information" element={<CompanyInformation />} />
          <Route path="/getting-started-guide" element={<GettingStartedGuide />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/gdpr-compliance-center" element={<GDPRComplianceCenter />} />
          <Route path="/seller-signup" element={<SellerSignup />} />
          <Route path="/manufacturer-signup" element={<ManufacturerSignup />} />
          <Route path="/supplier-signup" element={<SupplierSignup />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/signup" element={<Signup />} /> {/* NEW: Signup Route */}
          <Route path="/checkout" element={<CheckoutPortalWrapper />} />
          <Route path="/diagnostic-report" element={<DiagnosticReport />} />
          <Route path="/services-garage" element={<ServicesGarage />} />
          <Route path="/shop-dashboard" element={<ProtectedRoute requiredRole="Shop"><ShopDashboard /></ProtectedRoute>} />
          
          <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmation />} />
          <Route path="/product-reviews-ratings" element={<ProductReviewsRatings />} />
          <Route path="/seller-reviews-ratings" element={<SellerReviewsRatings />} /> {/* NEW: Seller Reviews Page */}
          <Route path="/review-submission-form" element={<ReviewSubmissionForm />} />

          <Route path="/seller-dashboard" element={<ProtectedRoute requiredRole="Seller"><SellerAccountDashboard /></ProtectedRoute>} />
          <Route path="/manufacturing-dashboard" element={<ProtectedRoute requiredRole="Manufacturer"><ManufacturingAccountDashboard /></ProtectedRoute>} />
          <Route path="/store/:slug" element={<PublicStorefront />} />
          <Route path="/store/:slug/:category" element={<PublicStorefront />} />
          
          {/* Broad SEO Intent Routes - Placed last to avoid catching legitimate root paths */}
          <Route path="/vehicle/*" element={<ModelViewer />} />
          <Route path="/product/*" element={<ModelViewer />} />

          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
  );
}